import axios from '../http'


function get(docsId) {
    return axios.get('/general/docs/get?docsId=' + docsId);
}

function printStartOrder(id) {
    const url = "/general/docs/printStartOrder?id="+id;
    return axios.get(url, { responseType: 'blob' }).then((res) => {
        const pdfUrl = window.URL.createObjectURL(new Blob([res], { type: 'application/pdf;charset=UTF-8'}));
        const newWindow = window.open(pdfUrl);
        window.URL.revokeObjectURL(newWindow);
    })
}

function printResultOrder(id) {
    const url = "/general/docs/printResultOrder?id="+id;
    return axios.get(url, { responseType: 'blob' }).then((res) => {
        const pdfUrl = window.URL.createObjectURL(new Blob([res], { type: 'application/pdf;charset=UTF-8'}));
        const newWindow = window.open(pdfUrl);
        window.URL.revokeObjectURL(newWindow);
    })
}

function matchMap(id) {
    return axios.get("/general/docs/matchMap?id="+id);
}

export default {
    get,
    printStartOrder,
    printResultOrder,
    matchMap
}